module.exports = __webpack_public_path__ + "img/product_img3.54762d08.png";